module.exports = __webpack_public_path__ + "media/images/athletes/1601-8eb81b38db47e8aacb769b5e9ce20d5b.png";